// Keep the input usable while its optional search transport is downloaded.
// Share the first load between focus and typing; allow retry after a load error.
export function createLazySearchClient(loadClient) {
    let pending = null;
    const prepare = () => {
        if (!pending) {
            pending = Promise.resolve().then(loadClient).catch(error => {
                pending = null;
                throw error;
            });
        }
        return pending;
    };
    return {
        prepare,
        async search(requests) {
            return (await prepare()).search(requests);
        },
    };
}
